import Pusher from 'pusher-js';
import Echo from "laravel-echo";

let socket = null;

export default class Sockets {

    echo;

    constructor() {
        console.log(`Setting up socket session with server: ${process.env.REACT_APP_WEBSOCKET_HOST} on port: ${process.env.REACT_APP_WEBSOCKET_PORT}`);

        this.echo = new Echo({
            broadcaster: 'pusher',
            key: 'EQTqQKIOMW', // hard code
            wsHost: process.env.REACT_APP_WEBSOCKET_HOST, 
            enabledTransports: ['ws'],
            wsPort:Number(process.env.REACT_APP_WEBSOCKET_PORT),
            forceTLS: false,
            disableStats: false
        });
    }

    static shared() {
        if (!socket) {
            socket = new Sockets();
        }

        return socket;
    }

}